import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 md:col-span-1">
            <h3 className="text-base font-semibold text-foreground-950 mb-3">{t("nav_brand")}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{t("footer_disclaimer")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 uppercase tracking-wide">{t("footer_links")}</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer_home")}</a></li>
              <li><a href="/article/cssbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer_article")}</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("cta_main_site")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 uppercase tracking-wide">{t("footer_resources")}</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-foreground-600">{t("footer_categories")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer_shipping")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer_qc")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer_safety")}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3 uppercase tracking-wide">{t("footer_legal")}</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-foreground-600">{t("footer_privacy")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer_terms")}</span></li>
              <li><span className="text-sm text-foreground-600">{t("footer_contact")}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">&copy; {new Date().getFullYear()} cssbuybr.skin. {t("footer_rights")}</p>
          <div className="flex items-center gap-2">
            {categories.slice(0, 5).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}